//#region src/api/userActions/types.ts
let UserActionState = /* @__PURE__ */ function(UserActionState) {
	UserActionState[UserActionState["Started"] = 0] = "Started";
	UserActionState[UserActionState["Halted"] = 1] = "Halted";
	UserActionState[UserActionState["Cancelled"] = 2] = "Cancelled";
	UserActionState[UserActionState["Ended"] = 3] = "Ended";
	return UserActionState;
}({});
//#endregion
export { UserActionState };

//# sourceMappingURL=types.js.map